import moment from "moment";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { createPortal } from "react-dom";
import "../styles/actionButtons.scss";

const ActionButtons = ({ 
    comment, 
    currentUser, 
    onLike, 
    onDeleteClick, 
    isDeleteModalOpen, 
    onConfirmDelete,
    onCancelDelete,
    onToggleReply 
}) => {
    return (
        <div className="actions">
            <div className="like" onClick={onLike}>
                {comment.hasLiked ? (
                    <FavoriteIcon style={{ color: "red" }} />
                ) : (
                    <FavoriteBorderOutlinedIcon />
                )}

                <span className="likeCount">
                    {comment.likesCount || 0} likes
                </span>
            </div>

            <button className="reply" onClick={onToggleReply}>
                Reply
            </button>

            <span className="date">
                {moment(comment.createdAt).fromNow()}
            </span>

            {isDeleteModalOpen && createPortal(
                <div className="delete-modal-overlay">
                    <div className="delete-modal-content">
                        <h3>
                            Delete Comment
                        </h3>

                        <p>
                            Are you sure you want to delete this comment? This action cannot be undone.
                        </p>

                        <div className="modal-buttons">
                            <button type="button" className="cancel-btn" onClick={onCancelDelete}>
                                Cancel
                            </button>

                            <button type="button" className="confirm-btn" onClick={onConfirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default ActionButtons;